<template>
    <div class="main">
        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">

                <el-tab-pane label="MONTAR RELATÓRIO" name="montar">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Relatório base">
                                <el-select v-model="base" @change="changeBase" placeholder="Selecione a origem dos dados" style="width: 100%;">
                                    <el-option v-for="r in catalogo" :key="r.relatorio_base" :label="r.nome" :value="r.relatorio_base"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Modelo salvo (opcional)">
                                <el-select v-model="modeloId" @change="aplicarModelo" clearable placeholder="Carregar um modelo" style="width: 100%;">
                                    <el-option v-for="m in modelos" :key="m.id" :label="m.nome" :value="m.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Colunas: SOMENTE as que o backend declarou. A tela não inventa campo. -->
                    <el-row :gutter="10" v-if="config.colunas">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Colunas do relatório">
                                <el-checkbox-group v-model="colunas">
                                    <el-checkbox v-for="c in config.colunas" :key="c.campo" :label="c.campo" border class="u-mb-5">
                                        {{ c.rotulo }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                                <el-select @change="getTurmas()" v-model="filtro.instituicao_id" filterable clearable placeholder="Pesquisar Instituição" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-else>
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Período">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" v-if="config.escopo === 'turma'">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Turma">
                                <el-select v-model="filtro.turma_id" clearable filterable placeholder="Selecione a turma" style="width: 100%;">
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="turma in grupo" :key="turma.id" :label="`${turma.curso ? turma.curso.nome : ''} ${turma.nome}`" :value="turma.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div class="u-mt-10 u-text-right">
                        <el-button @click="visualizar()" :loading="carregando" :disabled="!podeGerar">
                            <i class="el-icon-view"></i> VISUALIZAR
                        </el-button>
                        <el-button class="u-ml-10" @click="imprimir()" type="primary" :disabled="!podeGerar">
                            <i class="el-icon-printer"></i> GERAR PDF
                        </el-button>
                        <el-button class="u-ml-10" @click="dialogModelo = true" :disabled="!podeGerar">
                            <i class="el-icon-star-off"></i> SALVAR MODELO
                        </el-button>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="RESULTADO" name="resultado">
                    <div v-if="erro" class="u-mb-10">
                        <el-alert :title="erro" type="error" :closable="false"></el-alert>
                    </div>

                    <div v-else-if="!resultado.linhas">
                        <el-alert title="Monte o relatório e clique em VISUALIZAR." type="info" :closable="false"></el-alert>
                    </div>

                    <div v-else>
                        <p class="u-mb-10"><b>{{ resultado.titulo }}</b> — {{ resultado.total }} registro(s)</p>

                        <el-table :data="resultado.linhas" border size="mini" v-if="resultado.total">
                            <el-table-column v-for="c in resultado.colunas" :key="c.campo"
                                             :prop="c.campo" :label="c.rotulo">
                                <template slot-scope="s">
                                    <!-- ausência de dado é declarada, não vira zero -->
                                    <span v-if="s.row[c.campo] === null || s.row[c.campo] === undefined || s.row[c.campo] === ''">—</span>
                                    <span v-else>{{ s.row[c.campo] }}</span>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-alert v-else title="Nenhum registro encontrado para os filtros informados." type="info" :closable="false"></el-alert>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="MEUS MODELOS" name="modelos">
                    <el-table :data="modelos" border size="mini">
                        <el-table-column prop="nome" label="Modelo"></el-table-column>
                        <el-table-column prop="relatorio_base" label="Base" width="180"></el-table-column>
                        <el-table-column label="Colunas">
                            <template slot-scope="s">{{ (s.row.colunas || []).length }}</template>
                        </el-table-column>
                        <el-table-column label="" width="110">
                            <template slot-scope="s">
                                <el-button size="mini" type="danger" @click="excluirModelo(s.row)">EXCLUIR</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>
        </el-form>

        <el-dialog title="Salvar modelo" :visible.sync="dialogModelo" width="420px">
            <el-form label-position="top">
                <el-form-item label="Nome do modelo">
                    <el-input v-model="novoModelo.nome" maxlength="100"></el-input>
                </el-form-item>
                <el-checkbox v-model="novoModelo.compartilhado">Compartilhar com a instituição</el-checkbox>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogModelo = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvarModelo()">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        tabAtivo: 'montar',
        catalogo: [],
        modelos: [],
        turmas: [],
        base: '',
        modeloId: '',
        colunas: [],
        resultado: {},
        erro: '',
        carregando: false,
        dialogModelo: false,
        novoModelo: { nome: '', compartilhado: false },
        filtro: { instituicao_id: '', periodo_letivo_id: '', turma_id: '' }
    }),
    computed: {
        /**
         * O tipo do usuário mora em `state.user`, não em `state.config` — `config` guarda
         * escola e período correntes, e NUNCA teve a chave `usuario`. Lendo o caminho
         * errado, `t` era sempre null e `ehSmed` sempre false: o select de instituição não
         * era renderizado, `filtro.instituicao_id` ficava vazio para perfis de rede (que
         * não têm escola no contexto), a lista de turmas nunca carregava e os botões
         * dependentes de `podeGerar` ficavam desabilitados para sempre.
         *
         * Perfis de abrangência de rede: 4, 5, 6, 7, 8 e 10.
         */
        ehSmed () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        },
        config () {
            return this.catalogo.find(r => r.relatorio_base === this.base) || {}
        },
        podeGerar () {
            if (!this.base || !this.colunas.length) return false
            if (this.config.escopo === 'turma') return !!this.filtro.turma_id
            return !!this.filtro.instituicao_id && !!this.filtro.periodo_letivo_id
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.getCatalogo()
        this.getModelos()
        this.getTurmas()
    },
    methods: {
        /** O catálogo de colunas vem do backend — a tela nunca monta campo por conta própria. */
        getCatalogo () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/relatorio-pedagogico/customizado/catalogo`,
                            this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }
                this.catalogo = d.relatorios || []
            }).catch(e => this.tratarFalha(e))
        },

        getModelos () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio-pedagogico/customizado/modelos`,
                             {}, this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }
                this.modelos = d.modelos || []
            }).catch(e => this.tratarFalha(e))
        },

        getTurmas () {
            this.filtro.turma_id = ''

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) { this.turmas = []; return }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`,
                            this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }
                this.turmas = d
            }).catch(e => this.tratarFalha(e))
        },

        changeBase () {
            this.colunas = []
            this.resultado = {}
            this.erro = ''
            this.modeloId = ''
        },

        aplicarModelo () {
            const m = this.modelos.find(x => x.id === this.modeloId)
            if (!m) return

            this.base = m.relatorio_base
            this.colunas = (m.colunas || []).slice()

            if (m.filtros && m.filtros.turma_id) this.filtro.turma_id = m.filtros.turma_id
        },

        payload () {
            const p = { relatorio_base: this.base, colunas: this.colunas }

            if (this.config.escopo === 'turma') {
                p.turma_id = this.filtro.turma_id
            } else {
                p.instituicao_id = this.filtro.instituicao_id
                p.periodo_letivo_id = this.filtro.periodo_letivo_id
            }

            return p
        },

        visualizar () {
            this.carregando = true
            this.erro = ''
            this.resultado = {}

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio-pedagogico/customizado/executar`,
                             this.payload(), this.$store.getters.getHeaderAuth).then(r => {
                this.carregando = false
                const d = r.data || {}

                // A tela LÊ a resposta antes de anunciar sucesso.
                if (d.erro || d.error) { this.erro = d.erro || d.error; this.tabAtivo = 'resultado'; return }

                this.resultado = d
                this.tabAtivo = 'resultado'
            }).catch(e => { this.carregando = false; this.tratarFalha(e) })
        },

        imprimir () {
            window.eventBus.$emit('print', {
                url: '/api/relatorio-pedagogico/customizado/imprimir',
                param: this.payload()
            })
        },

        salvarModelo () {
            if (!this.novoModelo.nome) { this.$message.warning('Informe o nome do modelo.'); return }

            const dados = Object.assign({}, this.payload(), {
                nome: this.novoModelo.nome,
                compartilhado: this.novoModelo.compartilhado,
                instituicao_id: this.filtro.instituicao_id,
                filtros: { turma_id: this.filtro.turma_id }
            })

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/relatorio-pedagogico/customizado/salvar-modelo`,
                             dados, this.$store.getters.getHeaderAuth).then(r => {
                const d = r.data || {}
                if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }

                this.dialogModelo = false
                this.novoModelo = { nome: '', compartilhado: false }
                this.$message.success('Modelo salvo.')
                this.getModelos()
            }).catch(e => this.tratarFalha(e))
        },

        excluirModelo (modelo) {
            this.$confirm(`Excluir o modelo "${modelo.nome}"?`, 'Confirmação', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/relatorio-pedagogico/customizado/modelo/${modelo.id}`,
                                   this.$store.getters.getHeaderAuth).then(r => {
                    const d = r.data || {}
                    if (d.erro || d.error) { this.$message.error(d.erro || d.error); return }

                    this.$message.success('Modelo excluído.')
                    this.getModelos()
                }).catch(e => this.tratarFalha(e))
            }).catch(() => {})
        },

        tratarFalha (e) {
            const d = (e && e.response && e.response.data) ? e.response.data : {}
            this.$message.error(d.erro || d.error || 'Não foi possível concluir a operação.')
        }
    }
}
</script>
